var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canEditRefused
    ? _c("div", { staticClass: "RefusedProductsEditor" }, [
        _c("h4", [_vm._v("Refused Products")]),
        _vm._v(" "),
        _c("p", { staticClass: "hint" }, [
          _vm._v(
            "\n\t\tProducts in this list will not have DB metadata or Fx/Media synced to this agent.\n\t\tAn optional expiration date may be set; the product is automatically un-refused when the agent's local date reaches that date.\n\t"
          ),
        ]),
        _vm._v(" "),
        _vm.editRefusedList.length === 0
          ? _c("div", { staticClass: "noneRefused" }, [
              _vm._v("No products are currently refused."),
            ])
          : _c("table", { staticClass: "refusedTable" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.sortedEditRefusedList, function (row) {
                  return _c("tr", { key: "ref" + row.productRootId }, [
                    _c("td", [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.productNameHtml(row.productRootId)
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "rootId" }, [
                        _vm._v("(#" + _vm._s(row.productRootId) + ")"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: row.expirationDate,
                            expression: "row.expirationDate",
                          },
                        ],
                        attrs: { type: "date", min: _vm.todayString },
                        domProps: { value: row.expirationDate },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(row, "expirationDate", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "removeBtn",
                          on: {
                            click: function ($event) {
                              return _vm.removeRefusedProduct(row.productRootId)
                            },
                          },
                        },
                        [_vm._v("Remove")]
                      ),
                    ]),
                  ])
                }),
                0
              ),
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "addRefused" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.addQuery,
                expression: "addQuery",
              },
            ],
            staticClass: "addSearch",
            attrs: { type: "text", placeholder: "Search products to refuse…" },
            domProps: { value: _vm.addQuery },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.addQuery = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.addQuery
            ? _c(
                "div",
                { staticClass: "addResults" },
                [
                  _vm.addableProducts.length === 0
                    ? _c("div", { staticClass: "noResults" }, [
                        _vm._v("No matching products."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.addableProducts, function (proot) {
                    return _c(
                      "button",
                      {
                        key: "add" + proot.ProductRootId,
                        staticClass: "addResultBtn",
                        on: {
                          click: function ($event) {
                            return _vm.addRefusedProduct(proot)
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(proot.InternalNameHtml),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "rootId" }, [
                          _vm._v("(#" + _vm._s(proot.ProductRootId) + ")"),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "commitRow" }, [
          _c(
            "button",
            {
              staticClass: "commitBtn",
              attrs: { disabled: _vm.committing },
              on: { click: _vm.commitRefusedProducts },
            },
            [
              _vm._v(
                _vm._s(_vm.committing ? "Saving…" : "Commit Refused Products")
              ),
            ]
          ),
          _vm._v(" "),
          _vm.commitMessage
            ? _c("span", { staticClass: "commitMessage" }, [
                _vm._v(_vm._s(_vm.commitMessage)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.commitError
            ? _c("span", { staticClass: "commitError" }, [
                _vm._v(_vm._s(_vm.commitError)),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Product")]),
        _c("th", [_vm._v("Expires (optional)")]),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }